import { Container } from '../../../odie';

import { FuguBlockProps } from '../../defs/block';
import { config } from '../../defs/config';
import { blockPositionView } from '../../util/blockTools';
import { FitWidthBlockSprite } from './FitWidthBlockSprite';
import SurroundingBees from './components/SurroundingBees';

// constants
//-------------------------------------------------------------------------
const manifest = {
  image: 'fugu/block.fugu.1.png',
  fx: 'fx.hive/',
};

/*
    fugu block view
*/
export class FuguBlockView extends Container {
  public hive: FitWidthBlockSprite;
  public bees: SurroundingBees;

  // init
  //-------------------------------------------------------------------------
  constructor(props: FuguBlockProps) {
    // create base view
    super();
    const size = config.tile.size;
    this.hive = new FitWidthBlockSprite(manifest.image, props);
    this.addChild(this.hive);
    this.bees = new SurroundingBees(this, size * 0.62);
    blockPositionView(this, props);
  }

  public static assets(): string[] {
    return Object.values(manifest);
  }
}
